'use strict';

var processInclude = require('base/util');
const { selectDefaultAttribute } = require('./product/detail');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/events'));

    registerQuantityListeners();
    registerCarouselListeners();
    registerShareModalListeners();
});

function registerQuantityListeners() {
    var plus = $(".productDetailPage__quantity__increase");
    var minus = $(".productDetailPage__quantity__reduce");
    var quantity = $('#quantity-select-val');

    plus.click(function () {
        quantity.val(Number(quantity.val()) + Number(quantity.attr('step')));
    });

    minus.click(function () {
        if (Number(quantity.val()) > Number(quantity.attr('min'))) {
            quantity.val(Number(quantity.val()) - Number(quantity.attr('step')));
        }
    });
}

function registerCarouselListeners() {
    var imageCarousel = $("div[id^=pdpCarousel-]");

    var watchCarouselZoom = function () {
        $("#pdpCarouselZoom, .carousel-item").click(function () {
            imageCarousel.addClass("zoom");
        });
    }

    var watchCloseCarousel = function () {
        $("#pdpCarouselClose, .zoom-background").click(function () {
            imageCarousel.removeClass("zoom");
        });
    }

    $('body').on('product:afterAttributeSelect', function () {
        watchCarouselZoom();
        watchCloseCarousel();
    });

    watchCarouselZoom();
    watchCloseCarousel();
}

function registerShareModalListeners() {
    var shareModal = $("div[id^=shareModal]");

    var watchCloseShare = function (shareModal) {
        $("#shareClose").click(function () {
            shareModal.removeClass("share");
        })

        var copyTextButton = document.getElementById("shareLink");

        $("#shareLink").click(function () {
            navigator.clipboard.writeText(copyTextButton.value);

            alert("Copied to clipboard");
        })
    }

    $("#shareButton").click(function () {
        shareModal.addClass("share");
    });

    $('body').on('product:afterAttributeSelect', function () {
        watchCloseShare(shareModal);
    });

    watchCloseShare(shareModal);
}